{
  "name": "@ar-agents/mcp",
  "version": "0.11.4",
  "description": "MCP (Model Context Protocol) server that exposes the @ar-agents/* toolkit (identity, mi-argentina, identity-attest, mercadopago, mercadolibre, whatsapp, banking, facturacion, shipping, boletin-oficial, igj, firma-digital, gde-tad) to any MCP host (Claude Desktop, Cursor, Codeium, etc.). One install, one config, all AR integrations for Argentina's sociedades de IA.",
  "keywords": [
    "mcp",
    "model-context-protocol",
    "claude-desktop",
    "cursor",
    "ar-agents",
    "argentina",
    "afip",
    "arca",
    "mercadopago",
    "mercadolibre",
    "meli",
    "whatsapp",
    "banking",
    "cbu",
    "bcra",
    "facturacion",
    "wsfe",
    "factura-electronica",
    "shipping",
    "andreani",
    "oca",
    "correo-argentino"
  ],
  "license": "MIT",
  "author": "Nazareno Clemente <naza@naza.ar>",
  "funding": {
    "type": "github",
    "url": "https://github.com/sponsors/naza00000"
  },
  "homepage": "https://github.com/ar-agents/ar-agents/tree/main/packages/mcp",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/ar-agents/ar-agents.git",
    "directory": "packages/mcp"
  },
  "bugs": {
    "url": "https://github.com/ar-agents/ar-agents/issues"
  },
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      },
      "require": {
        "types": "./dist/index.d.cts",
        "default": "./dist/index.cjs"
      }
    }
  },
  "bin": {
    "ar-agents-mcp": "./bin/ar-agents-mcp.js"
  },
  "files": [
    "dist",
    "bin",
    "README.md",
    "AGENTS.md",
    "CHANGELOG.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsup",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "typecheck": "tsc --noEmit",
    "lint": "echo 'no lint configured yet'",
    "validate": "publint && attw --pack .",
    "size": "size-limit",
    "clean": "rm -rf dist"
  },
  "size-limit": [
    {
      "name": "ESM",
      "path": "dist/index.js",
      "limit": "120 KB",
      "ignore": [
        "@modelcontextprotocol/sdk",
        "node:crypto",
        "crypto",
        "node:fs",
        "fs",
        "node:path",
        "path",
        "node:child_process",
        "node:url",
        "url",
        "node:util",
        "node:http",
        "http",
        "node:https",
        "https",
        "node:stream",
        "stream",
        "node:zlib",
        "zlib",
        "node:buffer",
        "buffer",
        "node:events",
        "events",
        "node:net",
        "net",
        "node:tls",
        "tls",
        "node-forge"
      ]
    }
  ],
  "dependencies": {
    "@ar-agents/banking": "workspace:*",
    "@ar-agents/boletin-oficial": "workspace:*",
    "@ar-agents/core": "workspace:*",
    "@ar-agents/facturacion": "workspace:*",
    "@ar-agents/firma-digital": "workspace:*",
    "@ar-agents/gde-tad": "workspace:*",
    "@ar-agents/identity": "workspace:*",
    "@ar-agents/identity-attest": "workspace:*",
    "@ar-agents/igj": "workspace:*",
    "@ar-agents/mercadolibre": "workspace:*",
    "@ar-agents/mercadopago": "workspace:*",
    "@ar-agents/mi-argentina": "workspace:*",
    "@ar-agents/shipping": "workspace:*",
    "@ar-agents/whatsapp": "workspace:*",
    "@modelcontextprotocol/sdk": "~1.29.0"
  },
  "peerDependencies": {
    "ai": ">=6.0.0",
    "zod": ">=3.0.0"
  },
  "devDependencies": {
    "@types/node": "^20.19.39",
    "ai": "^7.0.0",
    "tsup": "^8.3.5",
    "typescript": "^5.9.3",
    "vitest": "^2.1.8",
    "zod": "^4.4.3"
  },
  "publishConfig": {
    "access": "public",
    "provenance": true
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "mcpName": "io.github.ar-agents/mcp"
}
